<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formDatas.iuId" placeholder="请选择面试官" @change="partserch" size="small"
                        style="width: 140px" clearable v-if="iuPost == 2">
                        <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName"
                            :value="item.iuId" :key="item.iuId"
                            :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.ijaName" style="width: 140px" size="small " placeholder="请输入应聘者"
                        clearable></el-input>
                    <el-input v-model="formDatas.ijaPhone" style="width: 140px" size="small " placeholder="请输入手机号"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.ioiProgress" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="未开始" :value="1" key="2"></el-option>
                        <el-option label="视频回答" :value="2" key="1"></el-option>
                        <el-option label="辨色测试" :value="3" key="3"></el-option>
                        <el-option label="职业锚" :value="4" key="4"></el-option>
                        <el-option label="已完成" :value="5" key="5"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style="
            margin: 10px;
            width: 95%;
            display: flex;
            flex-direction: row-reverse;
          ">
                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ioiId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑视频库' : '新增视频库'" :visible.sync="dialog" width="70%" top="8vh"
                :before-close="handleClose">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height: 65vh">
                    <div style="
              width: 100%;
              height: 100%;
              overflow-y: scroll;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
                        <el-form-item label="类型" prop="iowType">
                            <el-select size="small" v-model="form.iowType" clearable placeholder="请选择类型"
                                style="width: 130px">
                                <el-option label="问题" :value="1" key="2"></el-option>
                                <el-option label="旁白" :value="2" key="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="岗位" prop="iopId">
                            <el-select size="small" v-model="form.iopId" clearable placeholder="请选择岗位"
                                style="width: 130px">
                                <el-option v-for="(item, index) in getIvOnlinePostList_data || []" :label="item.iopName"
                                    :value="item.iopId" :key="index"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="文字内容" prop="iowText">
                            <el-input v-model="form.iowText" style="width: 100%" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="提示" prop="iowTip">
                            <el-input v-model="form.iowTip" style="width: 100%" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="视频" prop="iowVideoPath">
                            <my-uploadVideo ref="iowVideoPathupload" @fileChange="iowVideoPathChange"
                                :filearr="iowVideoPathfileList" :limit="1" style="margin: 10px 5px 5px" type="video"
                                @removeAfter="form.iowVideoPath = ''">
                            </my-uploadVideo>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="isDetail" width="70%" top="8vh" :before-close="detailClose">
                <el-card style="width: 95%; margin: 15px auto">
                    <div style="
              font-size: 20px;
              font-weight: 600;
              color: #409eff;
              width: 95%;
              margin: 10px auto;
            ">
                        手机型号
                    </div>
                    <el-descriptions v-if="detailTable.ivOnlineInterviewPhoneModel" :column="5" border :labelStyle="{
                            color: '#409EFF',
                            textAlign: 'center',
                            width: '8%',
                            fontSize: '12px',
                        }" :contentStyle="{
                            textAlign: 'center',
                            width: '12%',
                            fontSize: '12px',
                        }">
                        <el-descriptions-item label="品牌">{{
                            detailTable.ivOnlineInterviewPhoneModel.yupmBrand
                        }}</el-descriptions-item>
                        <el-descriptions-item label="设备型号">{{
                                detailTable.ivOnlineInterviewPhoneModel.yupmModel
                            }}</el-descriptions-item>
                        <el-descriptions-item label="操作系统">{{
                                detailTable.ivOnlineInterviewPhoneModel.yupmSystem
                            }}</el-descriptions-item>
                        <el-descriptions-item label="设备内存大小">{{
                                detailTable.ivOnlineInterviewPhoneModel.yupmMemorySize
                            }}</el-descriptions-item>
                        <el-descriptions-item label="客户端平台">{{
                                detailTable.ivOnlineInterviewPhoneModel.yupmPlatform
                            }}</el-descriptions-item>
                    </el-descriptions>
                    <ve-table ref="vetableVideoErr" v-if="detailTable.ivOnlineInterviewPhoneModelErrorList"
                        :columns="columnVideoErr" :table-data="detailTable.ivOnlineInterviewPhoneModelErrorList"
                        :max-height="300" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ioipmeId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                </el-card>

                <el-card style="width: 95%; margin: 15px auto">
                    <div style="
              font-size: 20px;
              font-weight: 600;
              color: #409eff;
              width: 95%;
              margin: 10px auto;
            ">
                        视频回答
                    </div>
                    <ve-table ref="vetableVideo" v-if="detailTable.ivOnlineInterviewItemList" :columns="columnVideo"
                        :table-data="detailTable.ivOnlineInterviewItemList" :max-height="300" :border-x="true"
                        :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                        :checkbox-option="checkboxOption" row-key-field-name="ioiiId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="detailTable.ivOnlineInterviewItemList == 0" class="empty-data">
                        暂无数据
                    </div>
                </el-card>
                <el-card style="width: 95%; margin: 15px auto">
                    <div style="
              font-size: 20px;
              font-weight: 600;
              color: #409eff;
              width: 95%;
              margin: 10px auto;
            ">
                        辨色测试
                    </div>
                    <div class="textclass" v-if="detailTable.ivqPaperRecordEye" style="
              width: 95%;
              height: 350px;
              overflow-y: auto;
              margin: 15px auto;
              overflow-x: hidden;
            ">
                        <div id="" v-for="(item, index) in detailTable.ivqPaperRecordEye
                            .ivqPaperTopicList || []" :key="index">
                            <p style="margin: 15px 0; font-size: 16px">
                                {{ index + 1 }}.({{ item.qttName }}){{ item.qtName }}
                            </p>
                            <img style="height: 200px" :src="item.qtImg" alt="" />
                            <el-radio-group v-model="SMcheckList[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                                v-for="(topic, n) in item.ivqTopicItemList" :key="n" style="display: block"
                                text-color="red">
                                <el-radio :label="topic.qtiId" style="margin: 5px" size="medium" border
                                    v-model="item.qptAnswerIds" disabled>{{ topic.qtiValue }}</el-radio>
                            </el-radio-group>
                            <div style="color: #409eff">
                                <span>答题时间:{{
                            item.qptEditTime ? item.qptEditTime : "未做"
                        }}</span>
                            </div>
                            <div :style="{
                                color: item.qtScoreRight == 1 ? '#F56C6C' : '#67C23A',
                            }">
                                {{ item.qtScoreRight == 1 ? "错误" : "正确" }}
                            </div>
                        </div>
                    </div>
                </el-card>

                <el-card style="width: 95%; margin: 15px auto">
                    <div style="
              font-size: 20px;
              font-weight: 600;
              color: #409eff;
              width: 95%;
              margin: 10px auto;
            ">
                        职业锚
                    </div>
                    <div v-if="detailTable.ivqPaperRecordTwo" style="padding: 0 50px">
                        <el-collapse>
                            <el-collapse-item v-for="(item, index) in detailTable.ivqPaperRecordTwo
                            .iprResultTwoList || []">
                                <template slot="title">
                                    <p style="width: 100%">
                                        <span style="color: red"> {{ item.score }}分 </span>
                                        <span style="margin-left: 15px">{{ item.title }}</span>
                                    </p>
                                </template>
                                <p>
                                    {{ item.description }}
                                </p>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <div class="textclass" v-if="detailTable.ivqPaperRecordTwo" style="
              width: 95%;
              height: 350px;
              overflow-y: auto;
              margin: 15px auto;
              overflow-x: hidden;
            ">
                        <div id="" v-for="(item, index) in detailTable.ivqPaperRecordTwo
                .ivqPaperTopicList || []" :key="index">
                            <p style="margin: 15px 0; font-size: 16px">
                                {{ index + 1 }}.({{ item.qttName }}){{ item.qtName }}
                            </p>
                            <el-radio-group v-model="ZYMcheckList[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                                v-for="(topic, n) in item.ivqTopicItemList" :key="n" style="display: block"
                                text-color="red">
                                <el-radio :label="topic.qtiId" style="margin: 5px" size="medium" border
                                    v-model="item.qptAnswerIds" disabled>{{ topic.qtiValue }}</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-card>
            </el-dialog>
        </div>
        <div style="
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
        background-color: black;
      " v-if="isVideo">
            <div style="width: 100%; height: 100%; overflow: hidden; position: relative">
                <video controls :src="videofile" style="width: 100%; height: 100%"></video>
                <div style="
            width: 50px;
            height: 50px;
            background-color: rgba(255, 5, 5, 0.5);
            line-height: 50px;
            text-align: center;
            border-radius: 100%;
            font-size: 23px;
            color: white;
            position: absolute;
            top: -15px;
            right: -15px;
          " @click.capture.stop="videoPreViewClose()" v-if="videofile != ''">
                    ✖
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import config from "../../api/env.js";
import {
    addIvOnlineWare,
    deleteIvOnlineInterview,
    getIvOnlineInterviewList,
    updateIvOnlineWare,
    getPkqPaperRecordList,
    getIvOnlineInterviewDetailsOne,
    getIvUserList,
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getIvUserList_data: [],
            SMcheckList: [],
            ZYMcheckList: [],
            getIvOnlinePostList_data: [],
            dateStart: "",
            dateEnd: "",
            ioiId: "",
            videofile: "",
            isVideo: false,
            iowVideoPathfileList: [],
            isDetail: false,
            detailTable: [],
            columnVideoErr: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: "left",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ioipmeMethod",
                    key: "ioipmeMethod",
                    title: "方法",
                    width: 350,
                    align: "center",
                    edit: false,
                    fixed: "left",
                },
                {
                    field: "ioipmeMsg",
                    key: "ioipmeMsg",
                    title: "报错信息",
                    width: 350,
                    align: "center",
                    edit: false,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "时间",
                    width: 130,
                    align: "center",
                    edit: false,
                },
            ],
            columnVideo: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: "left",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "iowText",
                    key: "iowText",
                    title: "问题",
                    width: 350,
                    align: "center",
                    edit: false,
                    fixed: "left",
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "上传时间",
                    width: 130,
                    align: "center",
                    edit: false,
                },
                {
                    field: "ioiiAnswerPath",
                    key: "ioiiAnswerPath",
                    title: "回答视频",
                    width: 100,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <div
                                        style="color:red;"
                                        on-click={() => this.videoPreView(row.ioiiAnswerPath)}
                                    >
                                        {" "}
                                        预览
                                    </div>
                                }
                            </span>
                        );
                    },
                },
            ],
            postForm: {},
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: "ioiId",
            dialog: false,
            edit: false,
            form: {},
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: "left",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: "left",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ijaName",
                    key: "ijaName",
                    title: "应聘者",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "ijaPost",
                    key: "ijaPost",
                    title: "岗位",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "iuName",
                    key: "iuName",
                    title: "面试官",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "ijcName",
                    key: "ijcName",
                    title: "招聘渠道",
                    width: 180,
                    align: "center",
                    edit: false,
                },
                {
                    field: "ioiProgress",
                    key: "ioiProgress",
                    title: "状态",
                    width: 150,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.ioiProgress == 1 ? (
                                    <el-tag type="danger">未开始</el-tag>
                                ) : row.ioiProgress == 2 ? (
                                    <el-tag type="primary">视频回答</el-tag>
                                ) : row.ioiProgress == 3 ? (
                                    <el-tag type="danger">辨色测试</el-tag>
                                ) : row.ioiProgress == 4 ? (
                                    <el-tag type="warning">职业锚</el-tag>
                                ) : (
                                    <el-tag type="success">已完成</el-tag>
                                )}
                            </span>
                        );
                    },
                },
                {
                    field: "createtime",
                    key: "c",
                    title: "创建时间",
                    width: 160,
                    align: "center",
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    fixed: "right",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ioiProgress != 1?
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: blue"
                                        on-click={() => this.gotoDetail(row)}
                                    >
                                        详情
                                    </el-button>:''
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                iuId: "",
                ijaName: "",
                ijaPhone: "",
                ioiProgress: "",
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.iuPost = localStorage.getItem("iuPost");

        this.getList();
        getIvUserList({ iuJoinInterview: 2 }).then((res) => {
            this.getIvUserList_data = res.data;
        });
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        Out() {
            const bulkdata = {
                ioiId: this.ioiId,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
            };
            var s = qs.stringify(bulkdata);
            this.openLoading();
            var that = this;
            axios({
                method: "post",
                url: config.baseURL + "/pkq-case-video-look/exportPkqCaseVideoLook",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    userid: window.localStorage.getItem("paId"),
                },
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel",
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "统计.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success",
                    });
                }
            });
        },
        detailClose() {
            this.isDetail = false;
            this.dateEnd = "";
            this.dateStart = "";
        },

        gotoDetail(row) {
            this.ioiId = row.ioiId;
            getIvOnlineInterviewDetailsOne({ ioiId: row.ioiId }).then((res) => {
                this.detailTable = res.data;
                this.SMcheckList = [];
                this.ZYMcheckList = [];
                for (
                    var i = 0;
                    i < res.data.ivqPaperRecordEye.ivqPaperTopicList.length;
                    i++
                ) {
                    if (res.data.ivqPaperRecordEye.ivqPaperTopicList[i].qttId == 4) {
                        this.SMcheckList.push(
                            res.data.ivqPaperRecordEye.ivqPaperTopicList[i].qptAnswerIds || ""
                        );
                    } else {
                        this.SMcheckList.push(
                            (
                                res.data.ivqPaperRecordEye.ivqPaperTopicList[i].qptAnswerIds ||
                                ""
                            )
                                .split(",")
                                .map(Number)
                        );
                    }
                }
                for (
                    var i = 0;
                    i < res.data.ivqPaperRecordTwo.ivqPaperTopicList.length;
                    i++
                ) {
                    if (res.data.ivqPaperRecordTwo.ivqPaperTopicList[i].qttId == 4) {
                        this.ZYMcheckList.push(
                            res.data.ivqPaperRecordTwo.ivqPaperTopicList[i].qptAnswerIds || ""
                        );
                    } else {
                        this.ZYMcheckList.push(
                            (
                                res.data.ivqPaperRecordTwo.ivqPaperTopicList[i].qptAnswerIds ||
                                ""
                            )
                                .split(",")
                                .map(Number)
                        );
                    }
                }
                this.isDetail = true;
            });
        },
        gotoUp(row) {
            this.$confirm("是否确定要上架吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateIvOnlineWareUp({ ioiId: row.ioiId }).then((res) => {
                        this.getList();
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        gotoDown(row) {
            this.$confirm("是否确定要下架吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateIvOnlineWareDown({ ioiId: row.ioiId }).then((res) => {
                        this.getList();
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        videoPreView(file) {
            this.videofile = file;
            this.isVideo = true;
        },
        videoPreViewClose() {
            this.isVideo = false;
        },
        crCoverChange(file) {
            console.log(file);
            this.$set(this.form, "crCover", file[0]);
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        iowVideoPathChange(file) {
            console.log(file);
            this.$set(this.form, "iowVideoPath", file[0]);
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        handleDetail(row) {
            getPkqPaperRecordList({ ioiId: row.ioiId }).then((res) => {
                this.detailTable = res.data;
                this.isDetail = true;
            });
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvOnlineInterview({ ioiId: row.ioiId }).then((res) => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row));
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                const video = {
                    name: data.iowVideoPath,
                    url: data.iowVideoPath,
                };
                this.$set(this.iowVideoPathfileList, 0, video);
            });
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvOnlineWare(this.form).then((res) => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose();
                                this.getList();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvOnlineWare(this.form).then((res) => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose();
                                this.getList();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            }
        },
        BoxOpen() {
            this.dialog = true;
        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs["formRef"].resetFields();
            this.iowVideoPathfileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ioiId = row.ioiId;
                    //console.log(jsonObj);
                    updateIvOnlineWare(jsonObj).then((res) => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    });
                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection =
                    this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvOnlineInterviewList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvOnlineInterviewList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvOnlineInterviewList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                console.log(this.columns);
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
